<template>
  <div class="multi-step-form">
    <div class="multi-step-form-head">
      <slot name="head">
        <h3 class="multi-step-form-head__title">{{ currentTitle }}</h3>
        <p class="multi-step-form-head__subtitle">{{ currentSubtitle }}</p>
      </slot>
    </div>
    <div class="multi-step-form-body">
      <div
        v-for="page in maxStep"
        :key="page"
        class="multi-step-form-item"
        :class="`multi-step-${page}`"
      >
        <keep-alive>
          <slot :name="`step-${page}`" v-if="page === currentStep + 1"> </slot>
        </keep-alive>
      </div>
      <keep-alive> </keep-alive>
    </div>
    <div class="multi-step-form-foot">
      <slot name="foot">
        <div class="multi-step-form-foot__left">
          <button
            class="btn btn-secondary"
            @click="currentStep--"
            :disabled="currentStep === 0 || loading"
          >
            Geri
          </button>
        </div>
        <div class="multi-step-form-foot__fill">
          <span class="multi-step-form-foot__fill__badge"
            >{{ currentStep + 1 }} / {{ maxStep }}</span
          >
        </div>
        <div class="multi-step-form-foot__right">
          <button
            class="btn btn-primary"
            @click="handleNext"
            :disabled="loading"
          >
            {{
              loading
                ? 'Yükleniyor...'
                : currentStep === maxStep - 1
                ? 'Kaydet'
                : 'İleri'
            }}
          </button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiStepForm',
  props: {
    step: {
      type: Number,
      default: 0
    },
    loading: Boolean,
    maxStep: {
      type: Number,
      default: 3
    },
    stepTitles: {
      type: Array,
      default: () => []
    },
    title: String,
    subtitle: String
  },
  emits: ['submit', 'update:step'],
  methods: {
    handleNext() {
      if (this.isNext) {
        this.currentStep++
        return
      }
      this.$emit('submit', this.formState)
    }
  },
  computed: {
    currentStep: {
      get() {
        return this.step
      },
      set(step) {
        this.$emit('update:step', step)
      }
    },
    isNext() {
      return this.currentStep < this.maxStep - 1
    },
    isPrev() {
      return this.currentStep > 0
    },
    currentTitle() {
      if (this.stepTitles.length > 0) {
        return this.stepTitles[this.currentStep].title
      }
      return this.title
    },
    currentSubtitle() {
      if (this.stepTitles.length > 0) {
        return this.stepTitles[this.currentStep].subtitle
      }
      return this.subtitle
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/multi-step-form';
</style>
